<template>
	<div class="add-box">
		<el-dialog v-model="dialogVisible" :title="title" width="80%" height="60%" :before-close="handleClose">
			<el-tabs v-model="activeName">
				<el-tab-pane label="基本配置" name="first">
					<el-form ref="form" :model="faceStrategyReq" :rules="rules" label-width="150px">
						<el-row>
							<el-form-item label="策略名称:" prop="strategyName">
								<el-input v-model="faceStrategyReq.strategyName" type="text"></el-input>
							</el-form-item>

							<el-form-item label="策略ID:" class="mg_40">
								<el-input v-model="faceStrategyReq.id" type="text"
									disabled></el-input>
							</el-form-item>
						</el-row>
						<el-row>
							<el-form-item label="次数限制:">
								<el-switch active-text="限制" inactive-text="不限制" :active-value="1" :inactive-value="0"
									v-model="faceStrategyReq.accessNumLimit"></el-switch>
							</el-form-item>

							<el-form-item label="进出类型:" class="mg_40">
								<el-select v-model="faceStrategyReq.enterOrExit" placeholder="选择进出类型">
									<el-option label="学校进" :value="0"></el-option>
									<el-option label="学校出" :value="1"></el-option>
									<el-option label="宿舍进" :value="2"></el-option>
									<el-option label="宿舍出" :value="3"></el-option>
								</el-select>
							</el-form-item>
						</el-row>
						<el-row>
							<el-form-item label="创建时间: ">
								<el-input v-model="faceStrategyReq.createDate" type="text" disabled></el-input>
							</el-form-item>
							<el-form-item label="通行次数: " prop="allowCnt" class="mg_40">
								<el-input v-model="faceStrategyReq.allowCnt" type="number" @input="handleInput"></el-input>
							</el-form-item>
						</el-row>
						<el-row>
							<el-form-item label="更新时间: ">
								<el-input v-model="faceStrategyReq.updateDate" type="text" disabled></el-input>
							</el-form-item>

							<el-form-item label="策略备注: " class="mg_40">
								<el-input v-model="faceStrategyReq.remark" type="text"></el-input>
							</el-form-item>
						</el-row>
						<el-row>
							<el-form-item label="开始结束时间: " prop="time">
								<el-date-picker v-model="startEndTime" type="datetimerange" range-separator="至"
									start-placeholder="开始时间" end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss"
									value-format="YYYY-MM-DD HH:mm:ss" @change="pickerChangeStartEndTime">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="" class="mg_40:"></el-form-item>
						</el-row>
					</el-form>

					<div style="width: 100%;text-align: center;width: 100%;padding: 20px 0px;font-weight: bold;">星期时间段
					</div>

					<el-table stripe :border="true" class="table-Style" ref="multipleTable"
						:header-cell-style="{background:'#EDF6FF',color:'#000'}" :data="faceWeekDayReqs"
						tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column prop="data" label="星期" width="100">
							<template #default="scope">
								<span v-if="scope.row.weekday == 1">星期一</span>
								<span v-if="scope.row.weekday == 2">星期二</span>
								<span v-if="scope.row.weekday == 3">星期三</span>
								<span v-if="scope.row.weekday == 4">星期四</span>
								<span v-if="scope.row.weekday == 5">星期五</span>
								<span v-if="scope.row.weekday == 6">星期六</span>
								<span v-if="scope.row.weekday == 0">星期日</span>
							</template>
						</el-table-column>
						<el-table-column prop="time1" label="时间段1">
							<template #default="scope">
								<el-time-picker v-model="scope.row.time1" format="HH:mm:ss" value-format="HH:mm:ss"
									is-range range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
									placeholder="选择时间范围" style="width:100%;font-size: 10px;"
									@change="pickerChangeTime(scope.row)">
								</el-time-picker>
							</template>
						</el-table-column>
						<el-table-column prop="time2" label="时间段2">
							<template #default="scope">
								<el-time-picker v-model="scope.row.time2" format="HH:mm:ss" value-format="HH:mm:ss"
									is-range range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
									placeholder="选择时间范围" style="width:100%;font-size: 10px;"
									@change="pickerChangeTime(scope.row)">
								</el-time-picker>
							</template>
						</el-table-column>
						<el-table-column prop="time3" label="时间段3">
							<template #default="scope">
								<el-time-picker v-model="scope.row.time3" format="HH:mm:ss" value-format="HH:mm:ss"
									is-range range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
									placeholder="选择时间范围" style="width:100%;font-size: 10px;"
									@change="pickerChangeTime(scope.row)">
								</el-time-picker>
							</template>
						</el-table-column>
						<el-table-column prop="time4" label="时间段4">
							<template #default="scope">
								<el-time-picker v-model="scope.row.time4" format="HH:mm:ss" value-format="HH:mm:ss"
									is-range range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
									placeholder="选择时间范围" style="width:100%;font-size: 10px;"
									@change="pickerChangeTime(scope.row)">
								</el-time-picker>
							</template>
						</el-table-column>
						<el-table-column prop="time5" label="时间段5">
							<template #default="scope">
								<el-time-picker v-model="scope.row.time5" format="HH:mm:ss" value-format="HH:mm:ss"
									is-range range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
									placeholder="选择时间范围" style="width:100%;font-size: 10px;"
									@change="pickerChangeTime(scope.row)">
								</el-time-picker>
							</template>
						</el-table-column>
						<el-table-column prop="time6" label="时间段6">
							<template #default="scope">
								<el-time-picker v-model="scope.row.time6" format="HH:mm:ss" value-format="HH:mm:ss"
									is-range range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
									placeholder="选择时间范围" style="width:100%;font-size: 10px;"
									@change="pickerChangeTime(scope.row)">
								</el-time-picker>
							</template>
						</el-table-column>
					</el-table>

					<div class="dialog-footer">
						<el-button class="bottom" @click="handleClose">返回</el-button>
						<el-button class="bottom" :disabled="isDisabled" type="primary"
							@click="insertOrUpdateFaceStrategy">保存</el-button>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>
	</div>
</template>

<script>
	import {
		zipFileUpload,
		insertOrUpdateFaceStrategy
	} from '@/assets/api/renyuan';
	export default {
		props: ['titleValue', "objLookTeacher"],
		components: {},
		data() {
			return {
				title: '',
				activeName: 'first',
				isDisabled: false,
				dialogVisible: true,
				detailsObj: {},
				startEndTime: [],
				faceWeekDayReqs: [{
					weekday: 0
				}, {
					weekday: 1
				}, {
					weekday: 2
				}, {
					weekday: 3
				}, {
					weekday: 4
				}, {
					weekday: 5
				}, {
					weekday: 6
				}],
				faceStrategyReq: {
					enterOrExit:0
				},
				Dform: {
					loginId: '',
					schoolId: ""
				},
				rules: {
					strategyName: [{
						required: true,
						message: '策略名称',
						trigger: 'blur'
					}],
					allowCnt: [{
						required: true,
						message: '请输入通行次数',
						trigger: 'blur'
					}],
					
					time: [{
						required: true,
						message: '请选择开始结束时间',
						trigger: 'blur'
					}],
				}
			};
		},

		created() {
			this.title = this.titleValue
			this.Dform.loginId = this.objLookTeacher.id;
			this.Dform.schoolId = this.objLookTeacher.schoolId;
		},
		mounted() {
			if (JSON.stringify(this.objLookTeacher.detailsObj) != '{}') {
				this.title = '修改策略'
				this.faceStrategyReq = this.objLookTeacher.detailsObj;
				this.startEndTime.push(this.faceStrategyReq["stateDate"]);
				this.startEndTime.push(this.faceStrategyReq["endDate"]);
				this.faceWeekDayReqs = this.faceStrategyReq.faceWeekDays;
				this.fromdataTime();
			} else {
				this.title = '新增策略'
			}
		},

		methods: {
			handleClose() {
				this.$emit('backClick')
			},

			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log(this.multipleSelection, val, 'this.multipleSelection');
			},

			pickerChangeStartEndTime() {
				if (this.startEndTime) {
					this.faceStrategyReq.stateDate = this.startEndTime["0"];
					this.faceStrategyReq.endDate = this.startEndTime["1"];
				}
			},

			pickerChangeFn() {
				console.log(55555, this.Dform.startTime);
			},

			pickerChangeTime(time) {
				console.log(time)
			},

			selectFile(event) {
				this.$refs.fileInput.click();
			},

			handleFileChange(event) {
				this.file = event.target.files[0];
				this.filePath = this.file.name
			},

			fromdataTime() {
				let faceWeekDayReqs = [];
				this.faceStrategyReq.faceWeekDays.forEach((obj) => {
					let item = {};
					let entity = {};
					for (let i = 1; i <= 6; i++) {
						const timeKey = `time${i}`;
						if (obj[timeKey]) {
							let time = [];
							let data = JSON.parse(obj[timeKey]);
							time.push(data["startTime"]);
							time.push(data["endTime"]);
							entity[timeKey] = time;
						}
					}
					entity["weekday"] = obj["weekday"];
					faceWeekDayReqs.push(entity);
				});


				this.faceWeekDayReqs = faceWeekDayReqs;

				for (let i = 0; i <= 6; i++) {
					if (!this.faceWeekDayReqs.some(item => item.weekday === i)) {
						let data = {
							weekday: i
						};
						this.faceWeekDayReqs.push(data);
					}
				}

				this.faceWeekDayReqs = this.faceWeekDayReqs.sort((a, b) => a.weekday - b.weekday);
			},

			insertOrUpdateFaceStrategy() {
				this.Dform.faceStrategyReq = this.faceStrategyReq;
				let list = [];
				this.faceWeekDayReqs.forEach((obj) => {
					let entity = {};
					let isHaveData = false;
					for (let i = 1; i <= 6; i++) {
						const timeKey = `time${i}`;
						if (obj[timeKey] && Array.isArray(obj[timeKey])) {
							isHaveData = true;
							let data = {
								startTime: obj[timeKey][0],
								endTime: obj[timeKey][1]
							};
							entity[timeKey] = JSON.stringify(data)
						}
					}

					if (isHaveData) {
						entity.weekday = obj["weekday"]
					}

					if (Object.keys(entity).length > 0) {
						list.push(entity)
					}
				});
				this.Dform.faceStrategyReq = this.faceStrategyReq;
				this.Dform.faceStrategyReq.leaveLinkage = 0; //请假联动默认关闭
				this.Dform.faceWeekDayReqs = list;
				
				if(this.Dform.faceWeekDayReqs.length == 0){
					this.$message({
						type: 'error',
						message: '请设置通行时间！'
					});
					return;
				}
				
				if(this.startEndTime.length == 0){
					this.$message({
						type: 'error',
						message: '请设置开始结束时间！'
					});
					return;
				}
				
				
				if(this.faceStrategyReq.allowCnt == null || this.faceStrategyReq.allowCnt.length == 0){
					this.$message({
						type: 'error',
						message: '请设置通行次数！'
					});
					return;
				}
				
				if(this.faceStrategyReq.strategyName == null || this.faceStrategyReq.strategyName.length == 0){
					this.$message({
						type: 'error',
						message: '请设置策略名称！'
					});
					return;
				}
				
				insertOrUpdateFaceStrategy(this.Dform).then((res) => {
					if (res.data.code == 200) {
						if(res.data.message == "成功!"){
							this.$message({
								type: 'success',
								message: '操作成功！'
							});
						}else{
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					this.handleClose()
				}).catch((err) => {
					console.log(err);
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				})
			},

			handleInput(value) {
				const regex = /^[1-9]\d*$/;
				if (regex.test(value)) {
					this.faceStrategyReq.allowCnt = value;
				}else{
					this.$message({
						message: "请输入大于0的数",
						type: 'error'
					});
					
					if(value <= 0){
						this.faceStrategyReq.allowCnt = 1;
					}
				}
			}
		},
	};
</script>

<style scoped lang="scss">
	.my-custom-switch.el-switch {
		--el-switch-on-color: #00aa00;
		--el-switch-off-color: #ff0000;
	}

	.table-Style {
		text-align: center;
	}

	.dialog-footer {
		width: 100%;
		text-align: center;
		padding: 20px;

		.bottom {
			padding: 18px 30px;
		}
	}

	.save_setting {
		height: 35px;
		width: 80px;
		margin-left: -60px;
	}

	/deep/ {
		.el-dialog__body {
			max-height: 80%;
			overflow: auto;
		}

		.el-table .el-table__header-wrapper thead th {
			text-align: center;
			background-color: #f5f7fa;
		}

		.el-table .el-table__body-wrapper tbody td {
			text-align: center;
		}

		.el-row {
			display: flex;
		}

		.el-tabs__content {
			padding: 0px 50px;
		}

		.el-switch--small .el-switch__core {
			border-radius: 30px;
			height: 22px;
			font-size: 14px;
			min-width: 48px;
		}

		.el-date-editor--datetimerange {
			margin-right: 20px;
		}

		.el-input--small .el-switch--small {
			width: 100%;
		}

		.el-select .el-input__inner {
			height: 35px;
			line-height: 35px;
		}

		.el-form-item {
			display: flex;
			flex: 1;
		}


		.el-form-item--small .el-form-item__label {
			height: 35px;
			line-height: 35px;
		}

		.mg_40 {
			margin-left: 40px;
		}


		.el-input__inner {
			height: 35px;
			line-height: 35px;
		}


		.el-radio.el-radio--small .el-radio__inner {
			width: 14px;
			height: 14px;
		}

		.el-input__wrapper .el-select__wrapper {
			width: 100%;
			height: 35px;
			line-height: 35px;
		}

		.el-date-editor.el-input,
		.el-date-editor.el-input__wrapper {
			height: 35px !important;
		}

		.el-select__wrapper.el-tooltip__trigger.el-tooltip__trigger {
			height: 35px;
		}
	}
</style>